jQuery( document ).ready( function( $ ) {
    var nfSaveProgress = new NF_SaveProgress();
    nfSaveProgress.start();
});
